function MenuSectionHeader({ t, menuGroup }) {
  const title = menuGroup === "drink" ? t.titleDrink : t.titleFood;

  return (
    <header className="menu-premium-header">
      <p className="menu-premium-eyebrow">
        <span className="menu-premium-eyebrow-rule" aria-hidden="true" />
        <span className="menu-premium-bean" aria-hidden="true" />
        <span>{t.eyebrow}</span>
        <span className="menu-premium-bean" aria-hidden="true" />
        <span className="menu-premium-eyebrow-rule" aria-hidden="true" />
      </p>
      <h2 className="menu-premium-title">{title}</h2>
    </header>
  );
}

export default MenuSectionHeader;
